import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import {
	DriverType,
	RegistrationState
} from "store/features/registration/types";
import { Requester } from "./requester";

export const getDrivers = async (partner_id: string | null = "") => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partner_id}/driver/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getDriver = async (
	partnerId: string | null = "",
	driverId: string | null = ""
) => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partnerId}/driver/${driverId}/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return {
				...result,
				driver_license_expiration: result.driver_license_expiration
					? result.driver_license_expiration.split("T")[0]
					: ""
			};
		},
		error: (error) => {
			throw error;
		}
	});
};

export interface DriverResponse {
	id: string;
}

export const createOrUpdateDriver = async (
	partner_id: string | null,
	driver_id: string | null,
	driver: DriverType
) => {
	const access_token = await getAccessToken();

	const requestData = { ...driver };

	if (!driver_id) {
		return Requester.post({
			url: `${baseConfig.baseURL}/partner/${partner_id}/driver/`,
			token: `${access_token}`,
			tokenType: "Bearer",
			body: requestData,
			success: (result): DriverResponse => {
				return result;
			},
			error: (error) => {
				throw error;
			}
		});
	}

	return Requester.put({
		url: `${baseConfig.baseURL}/partner/${partner_id}/driver/${driver_id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): DriverResponse => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

/*
export const saveDriver = async (
	personalData: RegistrationState,
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	const requestData = { ...personalData };

	return Requester.put({
		url: `${baseConfig.baseURL}/driver/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
*/

export const deleteDriver = async (
	partner_id: string | null = "",
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	return Requester.delete({
		url: `${baseConfig.baseURL}/partner/${partner_id}/driver/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
